import { render } from "./SavedCollectionsList.vue?vue&type=template&id=76b99368&scoped=true"
import script from "./SavedCollectionsList.vue?vue&type=script&lang=js"
export * from "./SavedCollectionsList.vue?vue&type=script&lang=js"

import "./SavedCollectionsList.vue?vue&type=style&index=0&id=76b99368&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76b99368"]])

export default __exports__
import QTable from 'quasar/src/components/table/QTable.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QList from 'quasar/src/components/item/QList.js';
import QItem from 'quasar/src/components/item/QItem.js';
import QItemSection from 'quasar/src/components/item/QItemSection.js';
import QItemLabel from 'quasar/src/components/item/QItemLabel.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QInnerLoading from 'quasar/src/components/inner-loading/QInnerLoading.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTr from 'quasar/src/components/table/QTr.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTable,QIcon,QList,QItem,QItemSection,QItemLabel,QSeparator,QInnerLoading,QBtn,QTr});qInstall(script, 'directives', {ClosePopup});
